import app from '../app';
import Component from '../../common/Component';
import LinkButton from '../../common/components/LinkButton';
import SessionDropdown from './SessionDropdown';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
import GlobalSearch from './GlobalSearch';

/**
 * The `HeaderSecondary` component displays secondary header controls.
 */
export default class HeaderSecondary extends Component {
  view() {
    return m("ul", {
      className: "Header-controls"
    }, listItems(this.items().toArray()));
  }

  /**
   * Build an item list for the controls.
   */
  items() {
    const items = new ItemList();
    items.add('search', m(GlobalSearch, {
      state: app.search.state
    }), 30);
    items.add('help', m(LinkButton, {
      className: "Button Button--link",
      href: "https://docs.flarum.org/troubleshoot/",
      icon: "fas fa-question-circle",
      external: true,
      target: "_blank"
    }, app.translator.trans('core.admin.header.get_help')));
    items.add('session', m(SessionDropdown, null));
    return items;
  }
}
flarum.reg.add('core', 'admin/components/HeaderSecondary', HeaderSecondary);